var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.579 10.5c.358 0 .652-.12.883-.358.23-.238.346-.534.346-.887 0-.362-.116-.658-.346-.887-.231-.229-.525-.343-.883-.343s-.652.114-.883.343c-.23.23-.346.525-.346.887 0 .363.115.66.346.895.23.233.525.35.883.35zm.861-3.476a.162.162 0 00.12-.05.167.167 0 00.05-.122l.24-6.18C2.85.557 2.794.5 2.68.5H.676C.562.5.505.557.505.672l.24 6.18c0 .048.017.088.05.122.033.033.073.05.12.05z"
  })));
}
export default __webpack_public_path__ + "static/svg/exclamation.svg";
export { SvgExclamation as ReactComponent };